import Events from '@utilities/events';

const MENU_TOGGLE_BUTTON_HOOK = '[js-hook-menu-toggle]';

class Header {
    constructor(element) {
        this.element = element;
        this.menuToggleButton = element.querySelector(MENU_TOGGLE_BUTTON_HOOK);

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        if (!this.menuToggleButton) return;

        this.menuToggleButton.addEventListener('click', () => Events.$trigger('brand-banner::toggle'));
    }
}

export default Header;
